export interface EntraJobsFacetSearchData extends EntraJobsSearchData {
  searchWord: string;
  chipDataString: string;
}

export enum LogAction {
  Insert = 'Insert',
  Update = 'Update',
  UpdateButWasDelete = 'UpdateButWasDelete',
  Delete = 'Delete',
  Error = 'Error',
  Warning = 'Warning',
  NoAction = 'NoAction',
}

export interface JobAutocompleteItem {
  job_id: number;
  job_name: string;
}

export interface EntraJobsSearchData {
  jobName: string[];
  entity: string[];
  action: string[];
  timestamp: string | undefined | null;
  searchFacetFields: Array<any>;
}

function defaultData(): EntraJobsSearchData {
  return {
    jobName: [],
    entity: [],
    action: [],
    timestamp: undefined,
    searchFacetFields: [],
  };
}

export default {
  defaultData,
};
